import { axiosGet } from '@/api/handlers';
import { useQuery } from '@/api/hooks';
import {
  ConsecutiveFiscalYearsModel,
  ConsecutiveRequestAmountsModel,
} from '@/features/project/_models/consecutive';
import {
  ConsecutiveBudgetsModel,
  ConsecutiveExecutionsModel,
} from '../projects/_models/consecutive';
import { queryKeyMap } from '../review-sheet/utils/query-keys';

export const useConsecutiveFiscalYears = ({ id }: { id: string }) => {
  return useQuery({
    queryKey: queryKeyMap.consecutiveFiscalYears(id),
    queryFn: async () => {
      const res = await axiosGet(
        `/api/projects/${id}/consecutive/fiscal-years/`,
      );
      return ConsecutiveFiscalYearsModel.parse(res);
    },
    enabled: !!id,
  });
};

export const useConsecutiveRequestAmounts = (id: string) => {
  return useQuery({
    queryKey: queryKeyMap.consecutiveRequestAmounts(id),
    queryFn: async () => {
      const res = await axiosGet(
        `/api/projects/${id}/consecutive/request-amounts/`,
      );
      return ConsecutiveRequestAmountsModel.parse(res);
    },
    enabled: !!id,
  });
};

export const useConsecutiveBudgets = (id: string) => {
  return useQuery({
    queryKey: queryKeyMap.consecutiveBudgets(id),
    queryFn: async () => {
      const res = await axiosGet(`/api/projects/${id}/consecutive/budgets/`);
      return ConsecutiveBudgetsModel.parse(res);
    },
    enabled: !!id,
  });
};

export const useConsecutiveExecutions = (id: string) => {
  return useQuery({
    queryKey: queryKeyMap.consecutiveExecutions(id),
    queryFn: async () => {
      const res = await axiosGet(`/api/projects/${id}/consecutive/executions/`);
      return ConsecutiveExecutionsModel.parse(res);
    },
    enabled: !!id,
  });
};
